import React, { Component } from 'react'
import { Button } from 'react-bootstrap'
import TopBar from './topBar'

export default class ProgramBookingBar extends Component {
  render () {
    const {
      onCancelButtonClick,
      programName,
      programDates,
      bannerText
    } = this.props
    return (
      <TopBar className='program-booking-bar' bsStyle='warning'>
        <strong>Note:</strong>{' '}
        {bannerText || (
          <span>
            This page is ONLY for {programName} participants to book{' '}
            {programDates}
          </span>
        )}
        <Button
          bsStyle='primary'
          style={{ marginLeft: '1rem' }}
          onClick={onCancelButtonClick}
        >
          Go Back to Regular Booking
        </Button>
      </TopBar>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/topBars/programBookingBar.js